export { MenuTypeSelect as default } from './dispensary-header-menu-type-select';
